import * as Yup from 'yup';
import { postcodeRegex } from '../../../../constants/validation';

export default Yup.object().shape({
  supplier: Yup.object().shape({
    location_line_1: Yup.string().when('manualLocation', {
      is: true,
      then: Yup.string().required(
        'Knowing your address means we can plan how far events are from you.'
      ),
    }),
    location_line_2: Yup.string(),
    location_city: Yup.string().when('manualLocation', {
      is: true,
      then: Yup.string().required('Your city helps us select relevant events.'),
    }),
    postcode: Yup.string().when('manualLocation', {
      is: true,
      then: Yup.string()
        .matches(postcodeRegex, 'Please enter a valid postcode.')
        .required(
          'A postcode means we can find out how far events are from you.'
        ),
    }),
    locationAutocomplete: Yup.object().when('manualLocation', {
      is: value => {
        return !value;
      },
      then: Yup.object({
        value: Yup.string().required('Please search and select an address'),
      }),
    }),
  }),
});
